import { Paper, ScrollArea } from "@mantine/core";
import { Link, Outlet } from "react-router-dom";

import Logo from "@/components/Logo";
import { Header } from "../header";
import { Sidebar } from "../sidebar";
import classes from "./root.module.css";

export function DashboardLayout() {
  return (
    <div className={classes.root}>
      <Paper withBorder className={classes.sidebarWrapper} visibleFrom="xl">
        <div className={classes.logoWrapper}>
          <Link className={classes.logo} to="/">
            <Logo c="dark" size={28} />
          </Link>
        </div>
        <ScrollArea flex="1" px="md">
          <Sidebar />
        </ScrollArea>
      </Paper>
      <div className={classes.content}>
        <Header />
        <main className={classes.main}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
